import React, { useState, useEffect } from 'react';
import axios from 'axios';
import toast from './utils/Toast';
import Loader from './utils/Loader';
import Navbar from './utils/Navbr';
import './style/PendingBilling.css';
import { useNavigate } from 'react-router-dom';

// --- MOCK DATA ---
const MOCK_BILLING = [
    { id: 'TXN-778899', pub_id: 'PUB-1001', name: 'Rahul Sharma', amount: 5400, upi: 'rahul@okaxis', status: 'pending', date: '2023-10-26' },
    { id: 'TXN-779900', pub_id: 'PUB-1045', name: 'Aditya Verma', amount: 3825, upi: 'aditya.v@paytm', status: 'pending', date: '2023-10-25' },
    { id: 'TXN-780011', pub_id: 'PUB-1120', name: 'Sneha Gupta', amount: 11250, upi: 'sneha123@ybl', status: 'pending', date: '2023-10-24' },
    { id: 'TXN-781122', pub_id: 'PUB-1332', name: 'Vikram Singh', amount: 1350, upi: 'vikram.s@upi', status: 'pending', date: '2023-10-23' },
    { id: 'TXN-782233', pub_id: 'PUB-1405', name: 'Priya Das', amount: 8100, upi: 'priya.d@ibl', status: 'pending', date: '2023-10-22' }
];

const PendingBilling = () => {
    // --- State ---
    const [loading, setLoading] = useState(true);
    const [loader, setLoader] = useState(true);
    const navigate = useNavigate();
    const [billingList, setBillingList] = useState([]);
    const [filteredList, setFilteredList] = useState([]);
    const [search, setSearch] = useState('');
    const [selectedRows, setSelectedRows] = useState([]);
    const [processing, setProcessing] = useState(false);

    const getCookie = (name) => {
        const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
        return match ? decodeURIComponent(match[1]) : null;
    };

    // --- Fetch Data ---
    const fetchPendingBilling = async () => {
        setLoading(true);
        const adminToken = getCookie('adminToken');
        try {
            const response = await axios.post('https://publisher.cashbolt.in.net/server/', {
                action: 'fetchPendingBilling',
                adminToken: adminToken || 'demo_token'
            });

            if (response.data.status === true) {
                setBillingList(response.data.data);
                setFilteredList(response.data.data);
            } else {
                setBillingList(MOCK_BILLING);
                setFilteredList(MOCK_BILLING);
            }
        } catch (error) {
            setBillingList(MOCK_BILLING);
            setFilteredList(MOCK_BILLING);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const adminToken = getCookie('adminToken');

        const init = async () => {
            try {
                // ✅ 1. Admin Auth Check
                const authRes = await axios.post('https://publisher.cashbolt.in.net/server/', {
                    action: 'checkAuthAdmin',
                    adminToken
                });

                if (!authRes.data.status) {
                    toast.error(authRes.data.message || 'Admin session expired');
                    navigate('/cbMediaAdmin7/login');
                    return;
                }


                fetchPendingBilling();
            } catch (err) {
                toast.error('Admin auth check failed');
                navigate('/cbMediaAdmin7/login');
            } finally {
                setLoader(false);
            }
        };
        init();
    }, []);

    // --- Search Logic ---
    useEffect(() => {

        if (!search) {
            setFilteredList(billingList);
        } else {
            const lowerSearch = search.toLowerCase();
            const filtered = billingList.filter(item =>
                item.id.toLowerCase().includes(lowerSearch) ||
                item.name.toLowerCase().includes(lowerSearch) ||
                item.pub_id.toLowerCase().includes(lowerSearch)
            );
            setFilteredList(filtered);
        }
    }, [search, billingList]);

    // --- Actions ---
    const handleCopy = (text) => {
        navigator.clipboard.writeText(text);
        toast.success("UPI ID Copied!");
    };

    const handleSingleAction = async (txnId, action) => {
        if (!window.confirm(`Are you sure you want to ${action} this transaction?`)) return;

        await processAction([txnId], action);
    };

    const handleBulkAction = async (action) => {
        if (selectedRows.length === 0) return toast.warning("No rows selected");
        if (!window.confirm(`${action.toUpperCase()} ${selectedRows.length} transactions?`)) return;

        await processAction(selectedRows, action);
    };

    const processAction = async (ids, actionType) => {
        setProcessing(true);
        try {
            const response = await axios.post('https://publisher.cashbolt.in.net/server/', {
                action: 'processBilling',
                txn_ids: ids,
                type: actionType, // 'approve' or 'reject'
                adminToken: getCookie('adminToken') || 'demo_token'
            });

            if (response.data.status === true) {
                toast.success(`Success: ${ids.length} transactions ${actionType}ed`);
                // Remove processed items from list locally
                const remaining = billingList.filter(item => !ids.includes(item.id));
                setBillingList(remaining);
                setFilteredList(remaining); // Will trigger filter effect
                setSelectedRows([]);
            } else {
                toast.error("Operation Failed");
            }
        } catch (error) {
            // Mock success for demo
            toast.success(`Demo: ${ids.length} transactions ${actionType}ed`);
            const remaining = billingList.filter(item => !ids.includes(item.id));
            setBillingList(remaining);
            setFilteredList(remaining);
            setSelectedRows([]);
        } finally {
            setProcessing(false);
        }
    };

    // --- Selection Logic ---
    const toggleRow = (id) => {
        setSelectedRows(prev =>
            prev.includes(id) ? prev.filter(rowId => rowId !== id) : [...prev, id]
        );
    };

    const toggleAll = () => {
        if (selectedRows.length === filteredList.length) {
            setSelectedRows([]);
        } else {
            setSelectedRows(filteredList.map(item => item.id));
        }
    };

    const handleExport = (type) => {
        alert(`Exporting ${type.toUpperCase()}...`);
    };
    if (loader) return <Loader />;
    return (
        <div className="pb-wrapper_pb">
            <Navbar role="Administrator" isAdmin={true} />

            <div className="bg-shape_pb shape-1_pb"></div>
            <div className="bg-shape_pb shape-2_pb"></div>

            <div className="pb-content_pb">

                <div className="pb-header_pb">
                    <div className="header-text_pb">
                        <h2>Pending <span className="highlight_pb">Billing</span></h2>
                        <p>Manage withdrawal requests and payouts</p>
                    </div>

                    {/* Export Buttons */}
                    <div className="export-group_pb">
                        <button className="exp-btn_pb excel" onClick={() => handleExport('excel')}>Excel</button>
                        <button className="exp-btn_pb csv" onClick={() => handleExport('csv')}>CSV</button>
                        <button className="exp-btn_pb json" onClick={() => handleExport('json')}>JSON</button>
                    </div>
                </div>

                {/* --- Controls Bar --- */}
                <div className="controls-bar_pb">
                    <div className="search-box_pb">
                        <input
                            type="text"
                            placeholder="Search Txn ID, Name, Pub ID..."
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                        />
                        <span className="search-icon_pb">🔍</span>
                    </div>

                    {selectedRows.length > 0 && (
                        <div className="bulk-actions_pb">
                            <span>{selectedRows.length} Selected</span>
                            <div className="bulk-btns_pb">
                                <button className="bulk-btn_pb approve" onClick={() => handleBulkAction('approve')} disabled={processing}>
                                    Approve All
                                </button>
                                <button className="bulk-btn_pb reject" onClick={() => handleBulkAction('reject')} disabled={processing}>
                                    Reject All
                                </button>
                            </div>
                        </div>
                    )}
                </div>

                {/* --- Table --- */}
                <div className="table-card_pb">
                    {loading ? <div className="loader-container_perf"><div className="spinner_perf"></div><p>Loading Data...</p></div> : (
                        <div className="table-scroll_pb">
                            <table className="pb-table_pb">
                                <thead>
                                    <tr>
                                        <th className="check-col_pb">
                                            <input
                                                type="checkbox"
                                                className="custom-check_pb"
                                                checked={filteredList.length > 0 && selectedRows.length === filteredList.length}
                                                onChange={toggleAll}
                                            />
                                        </th>
                                        <th>Txn ID</th>
                                        <th>Pub ID</th>
                                        <th>Name</th>
                                        <th className="text-right_pb">Amount</th>
                                        <th>UPI ID</th>
                                        <th className="text-center_pb">Status</th>
                                        <th className="text-center_pb sticky-col_pb">Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredList.length > 0 ? (
                                        filteredList.map(row => (
                                            <tr key={row.id} className={`table-row_pb ${selectedRows.includes(row.id) ? 'selected_pb' : ''}`}>
                                                <td className="check-col_pb">
                                                    <input
                                                        type="checkbox"
                                                        className="custom-check_pb"
                                                        checked={selectedRows.includes(row.id)}
                                                        onChange={() => toggleRow(row.id)}
                                                    />
                                                </td>
                                                <td className="mono_pb">{row.id}</td>
                                                <td className="mono_pb muted_pb">{row.pub_id}</td>
                                                <td className="font-bold_pb">{row.name}</td>
                                                <td className="text-right_pb amount_pb">₹{row.amount.toLocaleString()}</td>
                                                <td>
                                                    <div className="upi-cell_pb" onClick={() => handleCopy(row.upi)} title="Click to Copy">
                                                        <span>{row.upi}</span>
                                                        <span className="copy-icon_pb">📋</span>
                                                    </div>
                                                </td>
                                                <td className="text-center_pb">
                                                    <span className="status-badge_pb pending">Pending</span>
                                                </td>
                                                <td className="sticky-col_pb actions-cell_pb">
                                                    <button
                                                        className="action-icon-btn_pb approve"
                                                        title="Approve"
                                                        onClick={() => handleSingleAction(row.id, 'approve')}
                                                        disabled={processing}
                                                    >
                                                        ✓
                                                    </button>
                                                    <button
                                                        className="action-icon-btn_pb reject"
                                                        title="Reject"
                                                        onClick={() => handleSingleAction(row.id, 'reject')}
                                                        disabled={processing}
                                                    >
                                                        ✕
                                                    </button>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="8" className="no-data_pb">No pending transactions found.</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>

            </div>
        </div>
    );
};

export default PendingBilling;